"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCompleteTextField = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const DebtorMenuItem_1 = require("../DebtorMenuItem/DebtorMenuItem");
const MenuItem_1 = require("../MenuItem/MenuItem");
const TextInput_1 = require("../TextInput/TextInput");
const react_autosuggest_1 = __importDefault(require("react-autosuggest"));
const match_1 = __importDefault(require("autosuggest-highlight/match"));
const parse_1 = __importDefault(require("autosuggest-highlight/parse"));
const ColumnedDropdownTitle_1 = __importDefault(require("../Dropdown/ColumnedDropdownTitle"));
const ColumnedDropdownItem_1 = __importDefault(require("../Dropdown/ColumnedDropdownItem"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const ClearIcon = Theme_1.styled.div `
  cursor: pointer;
  width: 20px;
  position: absolute;
  zindex: 1;
  right: 10px;
  top: 30px;
  height: 20px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  & > div {
    cursor: pointer;
    width: 12px;
    height: 12px;
  }
`;
const AutoCompleteTextField = (props) => {
    const { value, startIcon, startCreditBadge, onChange, onBlur, selectSuggestion, label, minCharCount, error, suggestionError, className, onFocus, variant, wrapContent, helperText, focusInputOnSuggestionClick = false, displaySuper = false, columns = [], disabledSuggestions = [], noSuggestionsFoundMessage, clearSearch, multiSection = false, renderSectionTitle, getSectionSuggestions, } = props;
    const inputRef = (0, react_1.useRef)();
    const [suggestions, setSuggestions] = (0, react_1.useState)([]);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [fetchSucceeded, setFetchSucceeded] = (0, react_1.useState)(false);
    const storeInputRef = (autosuggest) => {
        if (autosuggest !== null) {
            inputRef.current = autosuggest.input;
        }
    };
    const onClearSearch = () => {
        var _a;
        ((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus) && inputRef.current.focus();
        if (clearSearch) {
            clearSearch();
        }
    };
    return (React.createElement("div", { className: className, style: { position: 'relative' } },
        React.createElement(react_autosuggest_1.default, { ref: storeInputRef, suggestions: suggestions, onSuggestionsFetchRequested: onSuggestionsFetchRequested, onSuggestionsClearRequested: onSuggestionsClearRequested, getSuggestionValue: getSuggestionValue, renderSuggestion: renderSuggestion, renderSuggestionsContainer: renderSuggestionsContainer, renderInputComponent: renderInputComponent, onSuggestionSelected: selectSuggestion, shouldRenderSuggestions: shouldRenderSuggestions, focusInputOnSuggestionClick: focusInputOnSuggestionClick, inputProps: {
                value,
                startIcon,
                startCreditBadge,
                onChange,
                onBlur: () => {
                    onBlur && onBlur();
                    setFetchSucceeded(false);
                },
                label,
                error,
                onFocus,
                variant,
                helperText,
            }, theme: {
                container: { position: 'relative' },
                suggestionsContainerOpen: {
                    position: 'absolute',
                    zIndex: 1,
                    left: 0,
                    right: 0,
                    minWidth: '100%',
                    width: `${wrapContent ? 'auto' : 'max-content'}`,
                    boxShadow: '0 0 2px 0 rgba(0,0,0,0.12), 0 2px 2px 0 rgba(0,0,0,0.24)',
                    maxHeight: '250px',
                    overflow: `${props.type === 'columned' ? 'hidden' : 'auto'}`,
                },
                suggestionsList: {
                    margin: 0,
                    padding: 0,
                    minWidth: '100%',
                    listStyleType: 'none',
                },
            }, multiSection: multiSection, renderSectionTitle: renderSectionTitle, getSectionSuggestions: getSectionSuggestions }),
        props.clearSearch && props.value && (React.createElement(ClearIcon, { onClick: onClearSearch, "data-testid": "clearSearch" },
            React.createElement(Icon_1.default, { icon: "close" })))));
    function shouldRenderSuggestions(value) {
        return value.trim().length >= (minCharCount || 0);
    }
    function onSuggestionsClearRequested() {
        setSuggestions([]);
    }
    function onSuggestionsFetchRequested(values) {
        return __awaiter(this, void 0, void 0, function* () {
            setFetchSucceeded(false);
            if (suggestionError) {
                setSuggestions([{ name: 'showSuggestionError' }]);
            }
            else {
                if (props.getSuggestions) {
                    setIsLoading(true);
                    let suggestionsResult = yield props.getSuggestions(values.value);
                    if (suggestionsResult === 'canceled') {
                        suggestionsResult = suggestions;
                    }
                    else {
                        setIsLoading(false);
                    }
                    const max = props.maxResultsDisplayed || 5;
                    setSuggestions(suggestionsResult.splice(0, max));
                    setFetchSucceeded(true);
                }
                else {
                    const autoCompleteSuggestions = getSuggestions(values.value, props.suggestions);
                    setSuggestions(autoCompleteSuggestions);
                }
            }
        });
    }
    function getSuggestions(value, suggestions) {
        var _a;
        if (props.type === 'columned') {
            if (((_a = suggestions[0]) === null || _a === void 0 ? void 0 : _a.name) === 'showSuggestionError') {
                return suggestions;
            }
            else {
                return getAllFieldSuggestions(value, suggestions);
            }
        }
        else {
            const inputValue = value;
            let count = 0;
            return typeof inputValue !== 'string' || inputValue.length === 0
                ? []
                : suggestions.filter((suggestion) => {
                    const strippedSuggestion = suggestion.name
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '');
                    const strippedInput = inputValue
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '');
                    const keep = count < (props.maxResultsDisplayed || 5) &&
                        strippedSuggestion.includes(strippedInput);
                    if (keep) {
                        count += 1;
                    }
                    return keep;
                });
        }
    }
    function getAllFieldSuggestions(value, suggestions) {
        const inputValue = value;
        let count = 0;
        return typeof inputValue !== 'string' || inputValue.length === 0
            ? []
            : suggestions.filter((suggestion) => {
                const strippedInput = inputValue
                    .toLowerCase()
                    .replace(/[^a-z0-9]/g, '');
                let shouldKeep = false;
                for (const column of columns) {
                    if (suggestion[column.key]
                        .toString()
                        .toLowerCase()
                        .replace(/[^a-z0-9]/g, '')
                        .includes(strippedInput)) {
                        shouldKeep = true;
                        break;
                    }
                }
                const keep = count < (props.maxResultsDisplayed || 5) && shouldKeep;
                if (keep) {
                    count += 1;
                }
                return keep;
            });
    }
    function getSuggestionValue(suggestion) {
        return suggestion;
    }
    function renderInputComponent(inputProps) {
        return (React.createElement("div", null,
            React.createElement(TextInput_1.TextInput, Object.assign({}, inputProps, { isLoading: isLoading, autoComplete: false }))));
    }
    function renderSuggestionsContainer(passedProps) {
        const { containerProps, children, query } = passedProps;
        if (props.type === 'columned') {
            let noSuggestionStyle = {
                minWidth: '100%',
                width: 'max-content',
                boxShadow: 'rgba(0, 0, 0, 0.12) 0px 0px 2px 0px, rgba(0, 0, 0, 0.24) 0px 2px 2px 0px',
                maxHeight: '250px',
                overflow: 'hidden',
            };
            if (!children) {
                noSuggestionStyle = Object.assign(Object.assign({}, noSuggestionStyle), { position: 'absolute', zIndex: 1, left: 0, right: 0 });
            }
            return (React.createElement("div", Object.assign({}, containerProps),
                noSuggestionsFoundMessage && fetchSucceeded
                    ? shouldRenderSuggestions(query) &&
                        props.columns && (React.createElement("div", { style: noSuggestionStyle },
                        React.createElement("div", { style: {
                                overflow: 'auto',
                                maxHeight: '210px',
                                color: '#333333',
                                fontFamily: 'proxima-nova,arial,sans-serif',
                                fontSize: '14px',
                            } },
                            React.createElement(ColumnedDropdownTitle_1.default, { columns: columns }),
                            !children ? (React.createElement("div", { style: {
                                    backgroundColor: '#FFFFFF',
                                    paddingLeft: '12px',
                                    paddingTop: '15px',
                                    paddingBottom: '15px',
                                } }, noSuggestionsFoundMessage)) : undefined)))
                    : children &&
                        props.columns && (React.createElement(ColumnedDropdownTitle_1.default, { columns: columns })),
                suggestionError && children && props.columns && (React.createElement("div", { style: {
                        backgroundColor: '#FFFFFF',
                        padding: '14px 10px',
                        color: '#333333',
                        fontFamily: 'proxima-nova,arial,sans-serif',
                        fontSize: '14px',
                    } }, suggestionError)),
                !suggestionError && (React.createElement("div", { style: {
                        display: 'flex',
                        flex: '1 0 auto',
                        overflow: 'auto',
                        maxHeight: '210px',
                    } }, children))));
        }
        else {
            return React.createElement("div", Object.assign({}, containerProps), children);
        }
    }
    function doesExclusionMatch(exclusion, suggestion) {
        const matchCol = columns.find((col) => col.useAsDisabledSuggestionsKey);
        if (matchCol) {
            return exclusion[matchCol.key] === suggestion[matchCol.key];
        }
        else {
            return false;
        }
    }
    function renderSuggestion(suggestion, params) {
        const matches = (0, match_1.default)(suggestion.name, params.query);
        const parts = (0, parse_1.default)(suggestion.name, matches);
        const shouldBeDisabled = props.type === 'columned' && disabledSuggestions.length
            ? disabledSuggestions.some((exclusion) => doesExclusionMatch(exclusion, suggestion))
            : false;
        switch (props.type) {
            case 'debtor':
                return (React.createElement(DebtorMenuItem_1.DebtorMenuItem, { debtorInfo: suggestion, displaySuper: displaySuper }));
            case 'unformatted':
                return React.createElement(MenuItem_1.MenuItem, null, suggestion.name);
            case 'columned':
                return (React.createElement(ColumnedDropdownItem_1.default, { suggestion: suggestion, query: params.query, columns: columns, disabled: shouldBeDisabled }));
            default:
                return (React.createElement(MenuItem_1.MenuItem, null, parts.map((part, index) => (React.createElement("span", { key: String(index), style: { fontWeight: part.highlight ? 500 : 300 } }, part.text)))));
        }
    }
};
exports.AutoCompleteTextField = AutoCompleteTextField;
//# sourceMappingURL=AutoCompleteTextField.js.map